<template>
    <!-- TODO: InputBool? -->
    <label class="form-check-label text-nowrap d-flex flex-row flex-fill">
        <input
            class="form-check-input me-3"
            type="checkbox"
            v-model="checked"
        />

        <component
            v-if="renderer"
            :is="renderer"
            :value="value"
            v-bind="rendererProps"
        />
        <span v-else> {{ value }}</span>
    </label>
</template>
<script setup lang="ts" generic="TModelValue, TComponentProps">
import type { Component } from 'vue';
import { computed, ref } from 'vue';

const props = defineProps<{
    renderer?: string | Component; //| Component<TComponentProps>;
    value: TModelValue;
    rendererProps?: TComponentProps;
}>();

/**
 * The model value here is an array of TModelValues that we add and remove from
 * This might be unexpected, but this mimics binding checkboxes to an array (and thats essentially what we are doing here)
 */
const modelValue = defineModel<Array<TModelValue>>({
    required: true,
});

const checked = computed({
    get() {
        if (modelValue.value.length == 0) {
            return false;
        }

        return modelValue.value.includes(props.value);
    },
    set(value) {
        if (value) {
            // Add the value to the modelValue
            modelValue.value = [...modelValue.value, props.value];
        } else {
            // Remove the value from the modelValue
            modelValue.value = modelValue.value.filter((v) => v !== props.value);
        }
    },
});
</script>
